import {StyleRulesCallback, WithStyles, withStyles} from "@material-ui/core/styles";
import * as React from "react";

interface IProps {
    value: any;
    label: HTMLElement;
    isLast: boolean,
    isSelected: boolean,
    onOptionClick: (val: any) => void;
}

const styles: StyleRulesCallback = ({ palette, spacing }) => ({
    optionContainer: {
        fontWeight:400,
        backgroundColor: "#FFFFFF",
        padding: ".7em.8em",
        cursor: "pointer",
        textAlign: "initial",
        display: "flex",
        paddingTop: ".7em",
        paddingBottom: ".7em",
        paddingLeft: ".8em",
        paddingRight: "2.4em",
        "&:hover": {
            backgroundColor: "#F5FAFC",
        }
    },
    lastOption: {
        borderBottomRightRadius: 10,
        borderBottomLeftRadius:10
    },
    selectedOption: {
        fontWeight: 600
    }
});

@(withStyles(styles) as any)
export default class DropDownOption extends React.Component<
    IProps & Partial<WithStyles<any>>
    > {

    public render() {
        const { label, classes } = this.props;
        return (<div className={classes!.optionContainer + this.generateOptionClasses()} onClick={this.optionSelect}>{label}</div>);
    }

    private optionSelect = () => {
        const {onOptionClick, value,label} = this.props;
        onOptionClick({value, label});
    }

    private generateOptionClasses = () => {
        const {classes, isSelected, isLast } = this.props;
        let res =  ' ';
        if (isSelected) {
            res += classes!.selectedOption;
        }
        if (isLast) {
            res += " " + classes!.lastOption
        }
        return res;
    }
}


// WEBPACK FOOTER //
// ./src/components/FormDropdown/DropDownOption.tsx